import { Loader } from '@googlemaps/js-api-loader';
import { env } from './env';

// Declare global google types
declare global {
  interface Window {
    google: typeof google;
  }
}

export const initializeGoogleMaps = async () => {
  // Try multiple ways to get the API key
  const apiKey =
    env.GOOGLE_MAPS_API_KEY ||
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
    window.__GOOGLE_MAPS_API_KEY__; // In case it's defined globally

  console.log('Attempting to initialize Google Maps with API key:', !!apiKey);

  if (!apiKey) {
    throw new Error(
      'Google Maps API key is not configured. Please check your environment variables.',
    );
  }

  const loader = new Loader({
    apiKey,
    // OR
    // apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '', // For Vite
    version: 'weekly',
    libraries: ['places'],
  });

  try {
    const google = await loader.load();
    window.google = google;
    return google;
  } catch (error) {
    console.error('Error loading Google Maps:', error);
    throw error;
  }
};

console.log('Available env vars:', process.env);
